module.exports = __webpack_public_path__ + "img/商品企划ico.bafb8ac8.png";